import type { BasisTheory as BasisTheoryServices } from '@basis-theory/basis-theory-js/types/sdk';
import type { BasisTheoryElements } from '@basis-theory/basis-theory-js/types/elements';

type BasisTheoryClient = BasisTheoryServices & BasisTheoryElements;

let initialization: Promise<BasisTheoryClient> | undefined;

/** Load and initialize the provider without exposing provider errors to the rest of the app. */
async function loadBasisTheory(publicKey: string): Promise<BasisTheoryClient> {
  try {
    const { BasisTheory } = await import('@basis-theory/basis-theory-js');
    return await new BasisTheory().init(publicKey, { elements: true });
  } catch {
    throw new Error('Basis Theory SDK initialization failed.');
  }
}

/** Initialize Basis Theory once and share the same result with every caller. */
function resolveBasisTheoryClient(publicKey: string): Promise<BasisTheoryClient> {
  if (initialization) return initialization;
  if (!publicKey) return Promise.reject(new Error('Basis Theory configuration is invalid.'));

  initialization = loadBasisTheory(publicKey).catch((error) => {
    initialization = undefined;
    throw error;
  });

  return initialization;
}

export type { BasisTheoryClient };
export { resolveBasisTheoryClient };
